import { useState } from "react";
import { comics, getComicsByCategory } from "@/mocks/comics";
import { allCategories } from "@/mocks/categories";
import ComicCard from "@/components/base/ComicCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function FeaturedSection() {
  const [active, setActive] = useState<string>("all");

  const list = getComicsByCategory(active);

  return (
    <section className="bg-background-50 py-16 md:py-20" id="featured">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="热门推荐"
            title="编辑精选 · 追更不踩雷"
            desc="从各题材中筛选口碑与人气俱佳的作品，按类型切换浏览，快速找到你的下一部心头好。"
          />
          <div className="inline-flex flex-wrap gap-1 rounded-full bg-background-100 p-1">
            {allCategories.map((c) => (
              <button
                key={c.slug}
                type="button"
                onClick={() => setActive(c.slug)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                  active === c.slug
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-700 hover:bg-background-50"
                }`}
              >
                {c.shortName}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.slice(0, 8).map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}